import { UserAction } from "../../app-constants/index.js";

const MAX_ITEMS = 5;

const defaultState = {
  isLoading: false,
  isSaving: false,
  items: [],           // working list, up to MAX_ITEMS: { articleId, articleName, title, thumbnail, url }
  isPublished: false,
  publishedAt: null,
  dirty: false,        // unsaved changes since last fetch/save
  picker: { open: false, slotIndex: null },
  search: { query: "", results: [], isSearching: false },
};

const homepageTrendingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case UserAction.SET.ACTIVE_DOMAIN:
    case UserAction.SIGN_OUT.SUCCESS:
      return defaultState;

    case "homepageTrending.fetch.request":
      return { ...state, isLoading: true };
    case "homepageTrending.fetch.success":
      return {
        ...state,
        isLoading: false,
        dirty: false,
        items: action.items || [],
        isPublished: action.isPublished,
        publishedAt: action.publishedAt,
      };
    case "homepageTrending.fetch.failure":
      return { ...state, isLoading: false };

    case "homepageTrending.save.request":
      return { ...state, isSaving: true };
    case "homepageTrending.save.success":
      return { ...state, isSaving: false, dirty: false };
    case "homepageTrending.save.failure":
      return { ...state, isSaving: false };

    case "homepageTrending.items.set":
      return { ...state, items: action.items, dirty: true };

    case "homepageTrending.select": {
      const { article } = action;
      const slotIndex = state.picker.slotIndex;
      const dupeAt = state.items.findIndex((it) => it.articleId === article.articleId);
      if (dupeAt > -1 && dupeAt !== slotIndex) {
        // already present in another slot -> ignore, just close
        return { ...state, picker: { open: false, slotIndex: null } };
      }
      const items = state.items.slice();
      if (slotIndex === null || slotIndex >= items.length) {
        if (items.length >= MAX_ITEMS) return { ...state, picker: { open: false, slotIndex: null } };
        items.push(article);
      } else {
        items[slotIndex] = article;
      }
      return {
        ...state,
        items,
        dirty: true,
        picker: { open: false, slotIndex: null },
        search: { query: "", results: [], isSearching: false },
      };
    }

    case "homepageTrending.picker.open":
      return { ...state, picker: { open: true, slotIndex: action.slotIndex }, search: { query: "", results: [], isSearching: false } };
    case "homepageTrending.picker.close":
      return { ...state, picker: { open: false, slotIndex: null } };

    case "homepageTrending.search.request":
      return { ...state, search: { ...state.search, query: action.query, isSearching: true } };
    case "homepageTrending.search.success":
      return { ...state, search: { ...state.search, results: action.results, isSearching: false } };
    case "homepageTrending.search.failure":
      return { ...state, search: { ...state.search, isSearching: false } };

    default:
      return state;
  }
};

export default homepageTrendingReducer;
